import styled from 'styled-components';

export const PageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f7f9;
  background-image: linear-gradient(135deg, #f5f7f9 0%, #e3eeff 100%);
`;

export const FormContainer = styled.div`
  background: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 440px;
  position: relative;
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  margin-bottom: 30px;
`;

export const Logo = styled.img`
  width: 50px;
  height: 50px;
  object-fit: contain;
  margin-bottom: 0;
`;

export const BrandName = styled.h1`
  color: #316C6E;
  font-size: 24px;
  font-weight: bold;
  margin: 0;
  font-family: 'Josefin Sans', sans-serif;
`;

export const Title = styled.h2`
  color: #316C6E;
  margin: 20px 0;
  text-align: center;
  font-size: 20px;
  font-weight: 500;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  cursor: pointer;
  color: #666;
  
  &:hover {
    color: #333;
  }
`;

export const SwitchText = styled.p`
  text-align: center;
  margin-top: 20px;
  color: #666;
`;

export const SwitchLink = styled.span`
  color: #316C6E;
  cursor: pointer;
  text-decoration: underline;
  font-weight: 500;

  &:hover {
    color: #254F51;
  }
`; 